import React from 'react';
import BlockContainer from './BlockContainer';
import TestimonialRotator from '../TestimonialRotator';

export default function Testimonials({
  title,
  description,
  show,
  bgColor,
  textColor,
  padding,
}) {
  return show && (title || description) ? (
    <BlockContainer
      title={title}
      description={description}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      fullWidth
    >
      <TestimonialRotator />
    </BlockContainer>
  ) : null;
}
